/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Exit_FullscreenInputs */

const cs_workflow_exit_fullscreen = /** @type {(inputs: Workflow_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukončit celou obrazovku`)
};

const en_workflow_exit_fullscreen = /** @type {(inputs: Workflow_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit fullscreen`)
};

/**
* | output |
* | --- |
* | "Exit fullscreen" |
*
* @param {Workflow_Exit_FullscreenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_exit_fullscreen = /** @type {((inputs?: Workflow_Exit_FullscreenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Exit_FullscreenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_exit_fullscreen(inputs)
	return cs_workflow_exit_fullscreen(inputs)
});